import { useEffect } from 'react';


const Iframe = () => {
    return (
        <iframe className='hidden' src="https://auth.tria.so.app"></iframe>
    )
}
export default Iframe
